@if (templateBtn()) {
@if (!isCloseModal()) {
<div id="modal-container">
  <div class="modal open-modal" tabindex="-1" role="dialog">
    <div class="modal-dialog-box" role="document">
      <div class="modal-content" [ngClass]="type()">
        <!--Popup Header -->
        @if (isHeaderVisible()) {
        <div class="common-modal-header">
          <div class="form-row sp-btw">
            <div class="form-item">
              <h3>{{headerTitle() | translate}}</h3>
            </div>
          </div>
        </div>
        }
        <!-- Popup content -->
        <div [ngClass]="component()==='aliasComponent'?'w-auto modal-body-container':'modal-body-container'">
          <ng-container [ngTemplateOutlet]="showModalContent()"></ng-container>
        </div>
        <!-- Interactive Buttons -->
        @if (isFooterVisible()) {
        <div class="popup-footer" [ngClass]=" isInfoSectionAvailable() ? 'popup-footer-info':'popup-footer' ">
          @if (isInfoSectionAvailable()) {
          <div class="button-region">
            <span class="icon icon_info_round"></span>
            <span>{{'BP_EM_UPLOAD_IMP_INFO' | translate}}</span>
          </div>
          }
          <div class="button-region">
            @if (isCloseButtonVisible()) {
            <button class="delta" (click)="close()">
              <span>{{(closeButtonTitle() | translate) ? (closeButtonTitle() | translate):closeButtonTitle()}}</span>
            </button>
            }
            @if (isSaveButtonVisible()) {
            <div class="save-button-wrapper" (mouseenter)="showButtonTooltip = true"
              (mouseleave)="showButtonTooltip = false">
              @if (showButtonTooltip && showToolTip() && doneButtonDisabled() === 'INVALID') {
              <app-generic-tooltip [tooltip]="'BP_EM_ENGLISH_UPLOAD_IMP_INFO'" position="top"
                [anchorPos]="'top-center'"> </app-generic-tooltip>
              }
              <button class="beta" (click)="save()" [disabled]="doneButtonDisabled() === 'INVALID'"
                [attr.aria-disabled]="doneButtonDisabled() === 'INVALID'"
                [ngClass]="{'done-button-disable': doneButtonDisabled() === 'INVALID' }">
                <span>{{(saveButtonTitle() | translate) ? (saveButtonTitle() | translate):saveButtonTitle()}}</span>
              </button>
            </div>
            }
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>
}
}


@if (!templateBtn()) {
@if (!isCloseModal()) {
<div id="modal-container">
  <div class="modal open-modal" tabindex="-1" role="dialog">
    <div class="modal-dialog-box" role="document">
      <div class="modal-content" [ngClass]="type()">
        <div
          [ngClass]="component()==='partcipantsQrDownload'?'common-modal-header common-modal-header-qr':'common-modal-header'">
          <div class="form-row sp-btw row-padding">
            <div class="form-item">
              <h3>{{headerTitle() | translate}}</h3>
            </div>
            <div class="form-group">
            </div>
          </div>
        </div>
        <div
          [ngClass]="component()==='partcipantsQrDownload'?'partcipant-qr modal-body-container':'modal-body-container'">
          <ng-container [ngTemplateOutlet]="showModalContent()"></ng-container>
        </div>
        @if (isFooterVisible()) {
        <div class="form-group footer-section">
          <div class="button-region">
            @if (isCloseBtnVisible()) {
            <button class="delta" (click)="close()">
              <span>{{closeButtonTitle()}}</span>
            </button>
            }
            <button class="delta" (click)="close()">
              <span>{{'BP_CM_CLOSE_BTN_LBL' | translate}}</span>
            </button>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>
}
}